module.exports = __webpack_public_path__ + "img/society-joan-of-arc-avatar.68bb2cc4.png";